import { render, staticRenderFns } from "./attendanceNotification.vue?vue&type=template&id=458bcaf2&scoped=true"
import script from "./attendanceNotification.vue?vue&type=script&lang=js"
export * from "./attendanceNotification.vue?vue&type=script&lang=js"
import style0 from "./attendanceNotification.vue?vue&type=style&index=0&id=458bcaf2&prod&scoped=true&lang=css"
import style1 from "./attendanceNotification.vue?vue&type=style&index=1&id=458bcaf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458bcaf2",
  null
  
)

export default component.exports